import { getCurrentStage, sentryTracePropogationURL } from '@app/core/utilities/url.utilities';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/angular';

/**
 * Initializes Sentry error tracking and monitoring
 */
export function initializeSentry(): void {
  Sentry.init({
    dsn: environment.app.sentry.key,
    environment: getCurrentStage(),
    release: `apollo@${environment.app.version.slice(0, -2)}`,
    enabled: environment.production,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [sentryTracePropogationURL()],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.1,
  });
}
